import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { Declaration, DeclarationGoods, RecursivePartial } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  id: string;
  partialDeclaration: RecursivePartial<Declaration>;
  partialGoodsShipmentItem?: RecursivePartial<DeclarationGoods>;
  storeSavedDeclaration?: boolean;
}

export const useUpdatePartialDeclaration = () => {
  const queryClient = useQueryClient();

  return useMutation({
    // todo: default values are not passed to onSucces function
    mutationFn: async ({ partialDeclaration, partialGoodsShipmentItem, id, storeSavedDeclaration = true }: HookProps) => {
      const result = await apiClient.declarationsCrud.savePartialData.mutation({
        params: { id },
        body: { partialDeclaration, partialGoodsShipmentItem },
      });
      if (result.status !== 200) throw result.body;
      return result.body;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['declaration'] });
      toast.success('Declaration updated!');
    },
    onError: (error) => {
      showErrorToast(error, `Error updating the declaration!`);
    },
  });
};
